import { defineStore } from "pinia";

export const useUIStore = defineStore("UI", {
  state: () => {
    return {
      layout: "layout-plain",
      isSidebarOpened: true,
      loading: false,
    };
  },
  actions: {
    toggleSidebar() {
      this.isSidebarOpened = !this.isSidebarOpened;
    },
    setLoading(state) {
      this.loading = state
    }
  },
});
